import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import { teal, lightBlue } from '@mui/material/colors';
import CardHeader from '@mui/material/CardHeader'
import { useSelector } from 'react-redux'
import Map from '../components/chatbot/Map'
import Report from '../components/chatbot/Report'
import QuestionsDrawer from '../components/chatbot/QuestionsDrawer';
// import { useIdToken } from '../hooks/useLogin';
import FaultAlarm from '../components/chatbot/FaultAlarm';
import FormatTabularData from '../components/chatbot/FormatTabularData';
import AssetFormatTabularData from '../components/chatbot/AssetFormatTabularData';
import CopyToClipboard from '../utilities/CopyToClipboard';
import { selectFarmchatbotResult } from '../store/features/chatbotSlice';

const REFRESH_TOKEN_EVERY_X_MINUTES = 20 * 1000 * 60

export interface ChatResponseAnswer {
  response_data: {
    "data": any // ReportProps | string | number,
    "data_type": string,
    "data_unit": string,
    "machine_model": string,
    "machine_vin": string,
    "metric": string,
    "metric_type": string,
    "time": string,
    "company_name"?: string,
    "device_type"?: string
  },
  response_type: string
}

export interface ChatResultType {
  query: string,
  answer: ChatResponseAnswer[]
}


const ChatPage = () => {
  // const { getToken } = useIdToken()
  const [openDrawer, setOpenDrawer] = useState(false)
  const chatResults = useSelector(selectFarmchatbotResult)

  const toggleDrawer = () => setOpenDrawer((prev) => !prev)

  // useEffect(() => {
  //   getToken()
  //   const timer = setInterval(async () => {
  //     await getToken()
  //   }, REFRESH_TOKEN_EVERY_X_MINUTES);

  //   return () => {
  //     clearInterval(timer);
  //   }
  // }, []);

  useEffect(() => {
    const chatContainer = document.getElementById('chat-container')
    if (chatContainer) {
      chatContainer.scrollTo({
        top: chatContainer.scrollHeight - chatContainer.clientHeight,
        behavior: 'smooth'
      })
    }
  }, [chatResults])

  return (
    <>
      <Grid container component={Paper} height={'84vh'} sx={{ backgroundColor: '#f5f5f5', color: '#fff', overflowY: 'auto' }}>
        <Grid id="chat-container" height={'10px'} item
          xs={12}
          sx={{
            backgroundColor: '#f5f5f5',
            color: '#000',
            textAlign: 'left'
          }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: lightBlue['500'] }}>AI</Avatar>
            }
            title="Hi, this is FieldOps Chatbot helping you with the questions about CNH FieldOps precision farming applications. What would you like to ask today?"
          />
        </Grid>
        <Grid item xs={12} sx={{ pb: 5 }}>
          {chatResults && chatResults.map((e:any, index:number) => (
            <Grid container key={'outer-'+index}>
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: '#f5f5f5',
                  color: '#000',
                  textAlign: 'left'
                }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: teal[100] }}>H</Avatar>
                  }
                  title={e.query}
                />
              </Grid>
              <Grid
                item xs={12}
                sx={{
                  backgroundColor: '#f5f5f5',
                  color: '#000',
                  textAlign: 'left'
                }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: lightBlue['500'] }}>AI</Avatar>
                  }
                />
                <Grid container key={'inner-'+index}
                  justifyContent="center"
                  alignItems="center">
                  <Grid item xs={11}
                    sx={{
                      backgroundColor: '#f5f5f5', //434654
                      color: '#000',
                      textAlign: 'left',
                      px: 2
                    }}>
                      {
                        (e.answer[0].response_type === 'text' ||
                          e.answer[0].response_type === 'table'
                        ) && <div dangerouslySetInnerHTML={{ __html: e.answer[0].response_data.data }}></div>
                      }

                      {
                        (['idling_hours',
                          'working_hours', 'fuel_consumption', 'fuel_level', 'area'].includes(e.answer?.[0]?.response_data?.metric))
                        && <FormatTabularData data={e.answer} />
                      }

                      {
                        (['asset'].includes(e.answer[0].response_data.metric))
                        && <AssetFormatTabularData data={e.answer} />
                      }

                      {
                        (['alarm', 'fault'].includes(e.answer[0].response_data.metric))
                        && e.answer.map((ans:any, index:number) => {
                          return <FaultAlarm
                            key={index}
                            model={ans.response_data.machine_model}
                            vin={ans.response_data.machine_vin}
                            metric_type={ans.response_data.metric_type}
                            time={ans.response_data.time}
                            data={ans.response_data.data.toString()}
                          />
                        })
                      }

                      {
                        (e.answer[0].response_data.metric === 'location')
                        && <Map vehicleLocation={e.answer} />
                      }

                      {
                        (e.answer[0].response_type === 'report')
                        && <Report
                          workspaceId={e.answer[0].response_data.data?.workspace_id}
                          reportId={e.answer[0].response_data.data?.report_id} />
                      }
                      <CopyToClipboard id={index.toString()} result={e} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <QuestionsDrawer open={openDrawer} toggleDrawer={toggleDrawer} />
    </>
  );
}

export default ChatPage;